import { useQuery } from "@tanstack/react-query";

import { accounting } from "@/api/accounting";
import { Card, CardBody, EmptyState } from "@/components/ui";

/**
 * Funding rates — periodic perp/swap financing rates per instrument & venue.
 * Read-only; captured by the funding daemon and applied as overnight charges.
 */
export function AdminFundingRatesPage() {
  const list = useQuery({ queryKey: ["funding-rates"], queryFn: () => accounting.fundingRates() });

  return (
    <div className="space-y-3">
      <h1 className="text-base font-semibold text-term-fg">Funding rates</h1>
      <Card>
        <CardBody className="p-0">
          {list.isLoading ? (
            <div className="p-3 text-sm text-term-mute">Loading…</div>
          ) : !list.data || list.data.length === 0 ? (
            <EmptyState title="No funding rates" description="Captured financing rates appear here." />
          ) : (
            <table className="w-full text-xs">
              <thead className="bg-term-elev text-term-mute">
                <tr>
                  <th className="px-3 py-1.5 text-left text-2xs uppercase tracking-wider">When</th>
                  <th className="px-3 py-1.5 text-left text-2xs uppercase tracking-wider">Instrument</th>
                  <th className="px-3 py-1.5 text-left text-2xs uppercase tracking-wider">Venue</th>
                  <th className="px-3 py-1.5 text-right text-2xs uppercase tracking-wider">Rate</th>
                  <th className="px-3 py-1.5 text-right text-2xs uppercase tracking-wider">Mark</th>
                  <th className="px-3 py-1.5 text-right text-2xs uppercase tracking-wider">Interval s</th>
                </tr>
              </thead>
              <tbody>
                {list.data.map((f) => (
                  <tr key={f.id} className="border-t border-term-border hover:bg-term-elev">
                    <td className="px-3 py-1.5 tnum text-term-dim whitespace-nowrap">
                      {f.funded_at ? new Date(f.funded_at).toLocaleString() : "—"}
                    </td>
                    <td className="px-3 py-1.5 font-mono text-2xs text-term-dim">
                      {f.instrument_id ? f.instrument_id.slice(0, 8) : "—"}
                    </td>
                    <td className="px-3 py-1.5 text-2xs text-term-dim">{f.venue}</td>
                    <td className="px-3 py-1.5 text-right tnum text-term-fg">{f.rate}</td>
                    <td className="px-3 py-1.5 text-right tnum text-term-dim">{f.mark_price ?? "—"}</td>
                    <td className="px-3 py-1.5 text-right tnum text-term-dim">{f.interval_seconds ?? "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
